window.getEmployees = function (login) {
    let wrap = document.querySelector('.team-items');
    let loader = document.querySelector('.loader-wrap');

    const $team = $('.team-items');
    let html = '';

    $.ajax({
        url: '/get-employees',
        dataType: 'json',
        data: {
            login: login
        },
        type: 'POST',
        success: function(json) {
            let storage = $('input.env').data().storage

            const rules = {
                almaty: { name: 'Алматы', team: ['sulimenko', 'nem', 'mashukhey','lysyh','zhumadilov','bayakhmetova','ruslannem'] },
                astana: { name: 'Астана', team: ['kungaliyev', 'shayakhmet'] }
            };
            const first = rules.almaty.team.concat(rules.astana.team);

            for (const city of Object.keys(rules)) {
                $team.append(`
        <div class="city-group">
            <h3 class="city-title">${rules[city].name}</h3>
            <div class="employees"></div>
        </div>
    `);
                const $testBlock = $team.find('.city-group').last().find('.employees');

                for (const name of rules[city].team) {
                    if (json.data[name]) {
                        $testBlock.append(window.makeEmployee(json.data[name], storage));
                    }
                }
            }

            wrap.classList.add('loaded');
            loader.hidden = true;
        }
    });
}

window.makeEmployee = function (val,storage) {
    let social = '',
        description = (val.description) ? val.description.substr(0,val.description.indexOf('<br />')) : '';

    $.each(val.social, function (key, item) {
        social += '<a href="' + item + '" target="_blank"><i class="icon-' + key + '"></i></a>'
    });

    return `<div class="team-item-wrap-outside">
            <div class="team-item">
                <div class="team-item__img">
                    <img src="${storage}${val.photo}" alt="Здесь могла бы быть картинка :-(" onError="this.src=\'images/error/blank-avatar.png\'">
                </div>
                <div class="team-item__info">
                    <div class="team-item__name"> ${val.fio} </div>
                    <div class="team-item__position"> ${val.post} </div>
                    <div class="team-item__description"> ${description} </div>
                    <div class="bottom-section">
                        <div class="social-links">  ${social} </div>
                        <a class="email" href="mailto:${val.email}"> ${val.email}  </a>
                    </div>
                </div>
            </div>
        </div>`.trim()
}